export default __webpack_public_path__ + "static/mosaic-dont-light-9d326b13ae5281f10d0800326cd74328.png";